import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Phone, Heart, MapPin, FileText } from 'lucide-react';

const EmergencyPlanViewer = ({ plan }) => (
  <div className="space-y-6">
    {plan.emergency_contacts && plan.emergency_contacts.length > 0 && (
      <Card className="surface-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><Phone className="w-5 h-5 text-destructive" /> Emergency Contacts</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-3">
            {plan.emergency_contacts.map((contact, index) => (
              <div key={`view-contact-${contact.name || index}`} className="bg-muted/30 rounded-lg p-4" data-testid={`contact-view-${index}`}>
                <h4 className="font-semibold text-foreground">{contact.name}</h4>
                <p className="text-sm text-muted-foreground">{contact.relationship}</p>
                <div className="mt-2 space-y-1 text-sm">
                  <p className="text-foreground">
                    <strong>Phone:</strong>{' '}
                    <a href={`tel:${contact.phone}`} className="text-primary hover:underline">{contact.phone}</a>
                  </p>
                  {contact.email && (
                    <p className="text-foreground">
                      <strong>Email:</strong>{' '}
                      <a href={`mailto:${contact.email}`} className="text-primary hover:underline">{contact.email}</a>
                    </p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </CardContent>
      </Card>
    )}

    <Card className="surface-card">
      <CardHeader>
        <CardTitle className="flex items-center gap-2"><Heart className="w-5 h-5 text-destructive" /> Medical Information</CardTitle>
      </CardHeader>
      <CardContent className="space-y-4">
        {plan.medical_conditions && (
          <div>
            <h4 className="font-semibold text-foreground mb-2">Medical Conditions</h4>
            <p className="text-muted-foreground whitespace-pre-line">{plan.medical_conditions}</p>
          </div>
        )}
        {plan.allergies && (
          <div>
            <h4 className="font-semibold text-foreground mb-2">Allergies</h4>
            <p className="text-muted-foreground whitespace-pre-line">{plan.allergies}</p>
          </div>
        )}
        {plan.current_medications && (
          <div>
            <h4 className="font-semibold text-foreground mb-2">Current Medications</h4>
            <p className="text-muted-foreground whitespace-pre-line">{plan.current_medications}</p>
          </div>
        )}
      </CardContent>
    </Card>

    {(plan.insurance_info || plan.preferred_hospital || plan.primary_care_doctor) && (
      <Card className="surface-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><MapPin className="w-5 h-5 text-destructive" /> Healthcare Information</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {plan.insurance_info && (
            <div>
              <h4 className="font-semibold text-foreground mb-2">Insurance</h4>
              <p className="text-muted-foreground whitespace-pre-line">{plan.insurance_info}</p>
            </div>
          )}
          {plan.preferred_hospital && (
            <div>
              <h4 className="font-semibold text-foreground mb-2">Preferred Hospital</h4>
              <p className="text-muted-foreground">{plan.preferred_hospital}</p>
            </div>
          )}
          {plan.primary_care_doctor && (
            <div>
              <h4 className="font-semibold text-foreground mb-2">Primary Care Doctor</h4>
              <p className="text-muted-foreground">{plan.primary_care_doctor}</p>
            </div>
          )}
        </CardContent>
      </Card>
    )}

    {(plan.action_steps || plan.important_documents || plan.special_instructions) && (
      <Card className="surface-card">
        <CardHeader>
          <CardTitle className="flex items-center gap-2"><FileText className="w-5 h-5 text-destructive" /> Emergency Action Plan</CardTitle>
        </CardHeader>
        <CardContent className="space-y-4">
          {plan.action_steps && (
            <div>
              <h4 className="font-semibold text-foreground mb-2">Action Steps</h4>
              <p className="text-muted-foreground whitespace-pre-line">{plan.action_steps}</p>
            </div>
          )}
          {plan.important_documents && (
            <div>
              <h4 className="font-semibold text-foreground mb-2">Important Documents</h4>
              <p className="text-muted-foreground whitespace-pre-line">{plan.important_documents}</p>
            </div>
          )}
          {plan.special_instructions && (
            <div>
              <h4 className="font-semibold text-foreground mb-2">Special Instructions</h4>
              <p className="text-muted-foreground whitespace-pre-line">{plan.special_instructions}</p>
            </div>
          )}
        </CardContent>
      </Card>
    )}

    <p className="text-xs text-muted-foreground text-center">
      Last updated: {new Date(plan.updated_at).toLocaleString()}
    </p>
  </div>
);

export default EmergencyPlanViewer;
